import React from 'react';

export function Footer() {
  const logo = localStorage.getItem('companyLogo');

  return (
    <footer className="aws-footer py-4 px-6 mt-auto">
      <div className="flex justify-center items-center">
        <span className="text-sm text-gray-500">
          © {new Date().getFullYear()} Think Numbers. All rights reserved.
        </span>
      </div>
    </footer>
  );
}